import { CHAT_ENTITY_TYPE_CONTACT_INFO } from '../../../util/transaction';

export default ({ currentUser }) => {
    const { protectedData } = currentUser.attributes.profile;
    const { phoneNumber } = protectedData;

    const contactInfoBody = {
        type: CHAT_ENTITY_TYPE_CONTACT_INFO,
        phoneNumber,
    };
    return JSON.stringify(contactInfoBody);
};
